var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 14,
    fill: "url(#paint0_linear_3712_4415)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1133 15.75H18.2773C21.0547 11.1445 25.3789 10.9688 27.9805 11.4609C28.4023 11.5312 28.7188 11.8477 28.7891 12.2695C29.2812 14.8711 29.1055 19.1953 24.5 21.9727V25.1367C24.5 26.0156 24.0078 26.8594 23.2344 27.3164L20.1406 29.1445C19.8594 29.2852 19.543 29.3203 19.2969 29.1445C19.0156 29.0039 18.875 28.7227 18.875 28.4062V24.3984C18.875 23.5898 18.5586 22.8164 17.9961 22.2539C17.4336 21.6914 16.6602 21.375 15.8516 21.375H11.8438C11.5273 21.375 11.2461 21.2344 11.1055 20.9531C10.9297 20.707 10.9297 20.3906 11.1055 20.1094L12.9336 17.0156C13.3906 16.2422 14.2344 15.75 15.1133 15.75ZM24.5 14.3438C23.6914 14.3438 23.0938 14.9766 23.0938 15.75C23.0938 16.5586 23.6914 17.1562 24.5 17.1562C25.2734 17.1562 25.9062 16.5586 25.9062 15.75C25.9062 14.9766 25.2734 14.3438 24.5 14.3438ZM16.8359 27.7734C15.1133 29.5312 11 29.25 11 29.25C11 29.25 10.7188 25.1367 12.4414 23.4141C13.6719 22.2188 15.6406 22.2188 16.8359 23.4141C18.0312 24.6094 18.0312 26.5781 16.8359 27.7734ZM15.1836 25.0664C14.7969 24.6445 14.1289 24.6445 13.7422 25.0664C13.1445 25.6289 13.25 27 13.25 27C13.25 27 14.6211 27.1055 15.1836 26.5078C15.6055 26.1211 15.6055 25.4531 15.1836 25.0664Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3712_4415",
    x1: -15.6667,
    y1: 17.5,
    x2: 30.713,
    y2: 57.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7960E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999734,
    stopColor: "#EE99AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProIcon);
export default __webpack_public_path__ + "static/media/proIcon.bb663f0833b257f7279bb3bdc0c609d3.svg";
export { ForwardRef as ReactComponent };